import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import CustomerLink from './CustomLink';
import './Footer.css'
function Footer() {
  return (
    <div className='footer_container'>
      <div className='footer_social'>
        <a href="https://www.instagram.com/kerens_diamond?utm_source=qr" target="_blank" rel="noopener noreferrer"><InstagramIcon className='icon_f' /></a>
        <a href="https://www.facebook.com/keren.gamliel?locale=he_IL" target="_blank" rel="noopener noreferrer"><FacebookIcon className='icon_f' /></a>
      </div>
      <ul className='footer_col'>
        <li className='footer_col_title'>המוצרים שלי</li>
        <li><CustomerLink to={'/chocolates'}>פרלינים</CustomerLink></li>
        <li><CustomerLink to={'/cakes'}>עוגות</CustomerLink></li>
        <li><CustomerLink to={'/cookies'}>עוגיות</CustomerLink></li>
      </ul>
      <ul className='footer_col'>
        <li className='footer_col_title'>יצירת קשר</li>
        <li>טלפון: 050-9422951</li>
        <li>כתובת לאיסוף עצמי: כפר הנגיד רחוב הארז 217 </li>
        <li><a className='footer_feedback' href="https://docs.google.com/forms/d/e/1FAIpQLScqu6Z9gdl7ttdt_7ge7drMbO2kS65dd8v3aTdPnVpfq8Yt0A/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer">השאירו לנו פידבק</a></li>
      </ul>
      <p className='footer_copy'>Yaron Haroni&copy; :כל הזכויות שמורות</p>
    </div>
  )
}

export default Footer
